import { ALL_HEAD, BODER_CIRCLE, SUB_TRACT } from 'assets/images'
import ItemNFTStyled from './styled'
import { RateStar } from 'features/Horse/components'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { useTranslation } from 'react-i18next'
import MemoizedImageRaratyCommon from 'shared/MemoizedImage/RaratyCommon'
import MemoizedImageRaratyEpic from 'shared/MemoizedImage/RaratyEpic'
import MemoizedImageRaratyLegendary from 'shared/MemoizedImage/RaratyLegendary'
import MemoizedImageRaratyMythic from 'shared/MemoizedImage/RaratyMythic'
import MemoizedImageRaratyRare from 'shared/MemoizedImage/RaratyRare'
import { ShopTypeRariTy } from 'models'
interface ItemNFTProps {
  type?: string
  avt?: string
  level?: string
  itemName?: string
  amount?: number
  rarityType?: string
  onClick?: () => void
}

export default function ItemNFT({ onClick, avt, itemName, amount, level, type, rarityType, ...props }: ItemNFTProps) {
  const { t } = useTranslation()
  const generateRateLevel = (maxLevel: number, currentLevel: number): JSX.Element[] => {
    const rateStars: JSX.Element[] = []
    for (let i = 0; i < maxLevel; i++) {
      rateStars.push(<RateStar key={i} isActive={i < currentLevel} />)
    }
    return rateStars
  }
  const showIconRariTy = () => {
      const valueRariry = rarityType
      const handleKeySort = () => {
        switch (valueRariry) {
          case ShopTypeRariTy.ALL:
            return ''
          case ShopTypeRariTy.COMMON.toLocaleUpperCase(): {
            return <MemoizedImageRaratyCommon />
          }
          case ShopTypeRariTy.EPIC.toLocaleUpperCase(): {
            return <MemoizedImageRaratyEpic />
          }
          case ShopTypeRariTy.LEGENDARY.toLocaleUpperCase(): {
            return <MemoizedImageRaratyLegendary />
          }
          case ShopTypeRariTy.MYTHIC.toLocaleUpperCase(): {
            return <MemoizedImageRaratyMythic />
          }
          case ShopTypeRariTy.RARE.toLocaleUpperCase(): {
            return <MemoizedImageRaratyRare />
          }
          default:
            return valueRariry
        }
      }
      return handleKeySort()
    }
    const bgIconRariTy = () => {
      const valueRariry = rarityType
      const handleKeySort = () => {
        switch (valueRariry) {
          case ShopTypeRariTy.ALL:
            return ''
          case ShopTypeRariTy.COMMON.toLocaleUpperCase(): {
            return 'bg-common'
          }
          case ShopTypeRariTy.EPIC.toLocaleUpperCase(): {
            return 'bg-epic'
          }
          case ShopTypeRariTy.LEGENDARY.toLocaleUpperCase(): {
            return 'bg-legendary'
          }
          case ShopTypeRariTy.MYTHIC.toLocaleUpperCase(): {
            return 'bg-mythic'
          }
          case ShopTypeRariTy.RARE.toLocaleUpperCase(): {
            return 'bg-rare'
          }
          default:
            return ''
        }
      }
      return handleKeySort()
    }
  return (
    <ItemNFTStyled {...props}>
      <div className={`item ${type?.toLowerCase()} bg-rarity ${bgIconRariTy()}`}>
        <img className='sub-tract' src={SUB_TRACT} alt="" />
        <img className='avt-item' src={avt ?? ALL_HEAD} alt="" />
        <div className='rarity'>
          {showIconRariTy()}
        </div>
        <div className='description'>
          <div className="star-amount">
            {(level && type === 'DOPING') ? (
              <div className='level d-flex ps-2'>{generateRateLevel(3, Number(level))}</div>
            ) : ''}
          </div>
          <h4>{itemName}</h4>
        </div>
        {amount ? (
          <div className="numb">
            <img src={BODER_CIRCLE} alt="" />
            <span>{amount}</span>
          </div>
        ) : ''}
        <div className='btn-detail-container'>
          <button className='font-bold btn-detail' onClick={onClick} >
            <span className='color-white'>{t(`${NOTIFICATION_MESSAGE}.details`)}</span>
          </button>
        </div>
      </div>
    </ItemNFTStyled>
  )
}
